function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#main-menu-icon-account_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.933 27A1.937 1.937 0 010 25.067V1.933c0-.517.196-1 .564-1.358C.932.195 1.415 0 1.92 0h18.637c1.058 0 1.932.863 1.932 1.933v23.145a1.937 1.937 0 01-1.932 1.934H1.933V27zm18.74-25.067v23.145a.115.115 0 01-.115.115H1.92a.115.115 0 01-.115-.115V1.933c0-.057.046-.115.115-.115h18.637c.057 0 .115.046.115.115z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7 14.41H4.486a.91.91 0 01-.908-.91v-2.762a.91.91 0 01.908-.91h2.106V7.47A.91.91 0 017.5 6.56h2.6V3.88c0-.495.402-.91.908-.91h3.486a.91.91 0 01.909.91v2.37h2.6a.91.91 0 01.909.91V13.5c0 .718-.942.905-1.413.91h-4.8zm4.395-6.354v4.546H13.39v.012h-1.519V4.788h1.703v4.914c0 .507.402.91.909.91a.91.91 0 00.908-.91V8.056h1.703zm-7.006.311v4.235H8.398V8.367h1.69zm-3.497 3.28v.955H5.384v-.955h1.208z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.67 22.123a.91.91 0 01-.91-.91c0-.506.403-.909.91-.909h13.173c.494 0 .908.403.908.91 0 .506-.402.909-.908.909H4.67zM4.716 18.808a.91.91 0 01-.909-.909c0-.506.403-.91.909-.91H15.24a.91.91 0 01.908.91c0 .506-.402.91-.908.91H4.716z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "main-menu-icon-account_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h27v27H0z"
})));

function SvgMainMenuIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMainMenuIconAccount;